import { createStore } from 'vuex';
import CategoryModule from "@/store/category";
import CardTypeModule from "@/store/card_type";
import CityModule from "@/store/city";
import SbeModule from "@/store/sbe";
import FeedbackModule from "@/store/feedback";
import UserModule from "@/store/user";
import CardModule from "@/store/card";
import EventModule from './events'

export default createStore({
  modules: {
    categoryModule: CategoryModule,
    cardTypeModule: CardTypeModule,
    cityModule: CityModule,
    sbeModule: SbeModule,
    feedbackModule: FeedbackModule,
    userModule: UserModule,
    cardModule: CardModule,
    EventModule,
  }
});